<style lang="scss" scoped>
.class-container {
	width: 282px;
	margin: 0 5px 5px 0 !important;
	&__members {
	   font-size: 10px;
	   margin: -5px 0 0 30px;
	}
	&__name {
		margin-left: 10px;
		font-size: 15px;
		font-weight: 800;
	}
	&__right {
		float: right;
	}
	&__border-bottom {
		border-bottom: 1px solid #eee;
	}
	&__edit-button {
		margin-left:-10px;
		font-size:12px;
		padding: 7px;
	}
	&__edit-button-group {
		height: 40px;
	}
	&__new {
		background-color: rgba(103, 194, 58, .1);
		border-color: rgba(103,194,58,.2);
	}
	&__scroll {
		overflow: auto;
		height: 150px;
	}
}
.class-container__scroll {
}
.clearfix:before,
.clearfix:after {
	display: table;
	content: "";
}
.clearfix:after {
	clear: both
}
</style>
<template lang="pug">
	el-card.class-container(:bodyStyle="bodyStyle", shadow="hover", draggable @dragstart.native="drag" :id="misClass.id")
		mis-class(:id="misClass.id" :misClasses="misClasses", :allowRemoval="false", @create-class="createClass", :allowCreation="true", :persistedMatches="persistedMatches")
</template>

<script>
import MisClass from './MISClass.vue';
export default {
	components: {
		MisClass
	},
	props: {
    	misClass: Object,
		misClasses: Array,
		persistedMatches: Array,
	},
	data() {
		return {
			bodyStyle: {
				padding: '0px',
				margin: '0px'
			}
		};
	},
	computed: {
	},
	methods: {
		drag(ev) {
			console.log(ev.target.id)
			ev.dataTransfer.setData("draggedClassId", ev.target.id);
		},
		handleClose(className) {
			this.misClass.classrooms = this.misClass.classrooms.filter((misClass) => misClass !== className);
		},
		removeClass() {
		},
		createClass(id) {
			this.$emit('create-class', id)
		}
	}
};
</script>